"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGenplanImageSize = void 0;
var _react = require("react");
const useGenplanImageSize = imageRef => {
  const [imageSize, setImageSize] = (0, _react.useState)({
    width: 0,
    height: 0
  });
  (0, _react.useEffect)(() => {
    if (imageRef.current) {
      const img = new Image();
      img.src = imageRef.current.src;
      img.onload = () => {
        setImageSize({
          width: img.naturalWidth,
          height: img.naturalHeight
        });
      };
    }
  }, [imageRef]);
  return imageSize;
};
exports.useGenplanImageSize = useGenplanImageSize;